import PropTypes from "prop-types";
import React from "react";
import { Container, Row } from "reactstrap";
import { withTranslation } from "react-i18next";
import UserManagementContent from "./UserManagementContent";

const UserManagement = props => {
  document.title = "User Management | CurbDash";
  const user = JSON.parse(localStorage.getItem("authUser"));

  return (
    <React.Fragment>
      <div className="page-content" style={{ marginTop: -70, backgroundColor: "rgb(38, 37, 35)" }}>
        <Container fluid>
          <Row>
            <UserManagementContent token={user.token} />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

UserManagement.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(UserManagement);
